import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getActivitiesAction } from '../../../services/request';
import { ActivityList } from './activity/ActivityList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';

export const ActivityRecord = () => {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getActivitiesAction(search, 'GET'));
  const optionsRequest = useQuery(getActivitiesAction(null, 'OPTIONS'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [activities, setActivities] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [allResorts, setAllResorts] = React.useState([]);
  const [allSeasons, setAllSeasons] = React.useState([]);
  const [allTypes, setAllTypes] = React.useState([]);
  const [allPeriods, setAllPeriods] = React.useState([]);
  const [allCategories, setAllCategories] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setActivities(payload.results);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      setAllResorts(optionsRequest.payload.actions.GET.resort.choices);
      setAllSeasons(optionsRequest.payload.actions.GET.season.choices);
      setAllTypes(optionsRequest.payload.actions.GET.type.choices);
      setAllPeriods(optionsRequest.payload.actions.GET.period.choices);
      setAllCategories(optionsRequest.payload.actions.GET.category.choices);
    }
  }, [optionsRequest.loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setActivities(
        _.map(activities, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setActivities(_.filter(activities, obj => obj.id !== obj2.id));
    } else {
      setActivities([obj2, ...activities]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <ActivityList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        activities={activities}
        queryCallback={queryCallback}
        submitCallback={submitCallback}
        allResorts={allResorts}
        allSeasons={allSeasons}
        allTypes={allTypes}
        allPeriods={allPeriods}
        allCategories={allCategories} />
    </>
  );
};
